import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import GlobalStyle from './components/GlobalStyle';
import { theme } from './theme';
import { siteConfig } from './siteConfig';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AmazonPrivacy from './pages/AmazonPrivacy';

/** Clips the morphing blobs, which deliberately overhang their sections. */
const Root = styled.div`
  position: relative;
  overflow: hidden;
`;

const TopAnchor = styled.span`
  display: block;
`;

// One unlinked page alongside the homepage, and nothing navigates between the two, so the path
// is read once at mount rather than by a router that would cost ~18kB gzip on every homepage
// load. public/_redirects points /amazon-privacy at this shell.
const currentPath = (): string => window.location.pathname.replace(/\/+$/, '');

function App() {
  const isAmazonPrivacy = currentPath() === '/amazon-privacy';

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Root data-reduce-motion={siteConfig.reduceMotion || undefined}>
        <Navbar heroVariant={isAmazonPrivacy ? undefined : siteConfig.heroVariant} />
        <TopAnchor id="top" />
        {isAmazonPrivacy ? <AmazonPrivacy /> : <Home />}
        <Footer />
      </Root>
    </ThemeProvider>
  );
}

export default App;
